import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { Form, Field, Row, FileInput, Button, Popconfirm } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class Edit extends React.Component {
	
	@observable record = null;
	@observable error = null;

	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		if (this.id) {
			try {
				this.record = await store.model.Fraction.findById(this.id);
			}
			catch(e) {
				this.error = e.message;
			}
		}
		else {
			this.record = new store.model.Fraction();
		}
	};

	delete = async () => {
		try {
			await this.record.delete();
			this.props.history.push('/admin/fractions');
		} catch (err) {
			console.error('Не удалось удалить фракцию. Возможно фракция содержит депутатов', err);
			alert('Не удалось удалить фракцию. Возможно фракция содержит депутатов');
		}

	}
	
	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;
		
		const controls = this.record.id ? (
			<div style={{display: 'flex', justifyContent: 'flex-end'}}>
				<Popconfirm content="Вы действительно хотите удалить ФРАКЦИЮ?" onConfirm={this.delete}>
					<Button className="btn-danger" icon={<FontAwesomeIcon icon={faTrash}/>}>Удалить фракцию</Button>
				</Popconfirm>
			</div>
		) : null;

		return <>
			<p>Фракция</p>
			<Form record={this.record} rootPath="/admin" returnTo="/admin/fractions" noDelete controls={controls}>
				<div className="row">
					<div className="col-lg-8"><Field property="name" label="Наименование для отображения на странице депутата (под Ф.И.О. депутата)" /></div>
					<div className="col-lg-4"><Field property="shortName" label="Краткое наименование" /></div>
				</div>
				<Field property="fractionName" label="Наименование фракции (для отображения на странице фракции)" />
				<Field property="fractionText" label="Текст для отображения на странице депутата (раздел 'Членство в депутатских объединениях', в родительном падеже)" />
				<Row>
					<Field property="website" label="Сайт, название" />
					<Field property="websiteUrl" label="Сайт, ссылка" />
					<div />
				</Row>
				<Row>
					<Field property="file" label="Положение, файл"><FileInput property="file" /></Field>
					<Field property="fileName" label="Положение, название" />
					<div />
				</Row>
				<Row>
					<Field property="image" label="Изображение"><FileInput property="image" /></Field>
					<div />
					<div />
				</Row>
				<Field property="existing" label="Существует" />
				{this.record.image && typeof this.record.image === 'string' && <img src={this.record.downloadFile('image')} width={200} height={200} style={{ objectFit: 'content' }} />}
			</Form>
		</>;
	}	
}
